/* tslint:disable:max-line-length */
import * as React from 'react';
import pure from 'recompose/pure';

class EyeIcon extends React.Component<{ style: any }> {
  render() {
    return <svg
      width="25px"
      height="25px"
      viewBox="0 0 25 25"
      fill="currentcolor" {...this.props}>
      <g id="Symbols">
        <g id="eye">
          <g
            id="Group-7"
            transform="translate(1.000000, 5.000000)"
          >
            <g id="eye">
              <path
                d="M0,6.49400962 C0.24053734,6.19831927 5.3530241,0 10.9997932,0 C16.646907,0 21.7594627,6.19831927 22,6.50592863 C21.7594627,6.80161897 16.6469759,13 10.9997932,13 C5.3530241,13 0.24053734,6.80161897 0,6.49400962 Z M11.0144926,2 C8.49309549,2 6.44913491,4.01466718 6.44913491,6.49980213 C6.44913491,8.98533282 8.49315285,11 11.0144926,11 C13.5358323,11 15.5798503,8.98533282 15.5798503,6.49980213 C15.5798503,4.01466718 13.5358323,2 11.0144926,2 Z M10.999812,4.44406282 C9.84775158,4.44406282 8.91354691,5.36485292 8.91354691,6.5 C8.91354691,7.63594991 9.84737564,8.55674001 10.999812,8.55674001 C12.1522484,8.55674001 13.0865157,7.63632045 13.0865157,6.5 C13.0860772,5.36448239 12.1518725,4.44406282 10.999812,4.44406282 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>;
  }
}

const Icon = pure(EyeIcon);
Icon.displayName = 'EyeIcon';
export default Icon;
